import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_VALIDATIONS_REQUEST, GET_VALIDATIONS_SUCCESS, GET_VALIDATIONS_FAILURE,
    GET_VALIDATION_REQUEST, GET_VALIDATION_SUCCESS, GET_VALIDATION_FAILURE,
    GET_VALIDATION_HISTORY_REQUEST, GET_VALIDATION_HISTORY_SUCCESS, GET_VALIDATION_HISTORY_FAILURE,
    RESTART_VALIDATION_REQUEST, RESTART_VALIDATION_SUCCESS, RESTART_VALIDATION_FAILURE,
    BULK_RESTART_VALIDATIONS_REQUEST, BULK_RESTART_VALIDATIONS_SUCCESS, BULK_RESTART_VALIDATIONS_FAILURE,
    RESET_VALIDATIONS_STATE,
    GET_RISK_SUMMARY_REQUEST, GET_RISK_SUMMARY_SUCCESS, GET_RISK_SUMMARY_FAILURE
} from '../actions/validations.actions';


export interface Validation {
    uuid: string;
    firstName: string;
    lastName: string;
    email: string;
    roleUuid: string;
    isActive?: boolean;
    createdAt: any;
    hasPepSoe: number | -1;
    updated_datetime:any;
    validationConsumptions: any;
    reviews:any;
    showRestartButton?: boolean;
    delayDuration?: string;
}
export interface levArticles {
    accused: number;
    E_final: string;
    G_final: string;
    S_final: string;
    F_final: string;
    adverse: 0 | 1;
    credible_link: boolean;
    sourceCategory?: string | "";
    trashCategory?: string | "";
    detailed_prospect: string;
    isPublished: boolean;
    isTrash: boolean;
    language: string;
    legal_entity_idm: string;
    legal_entity_idm_percent: string;
    link: string;
    metadata_description: string;
    metadata_image_url: string;
    metadata_site_name: string;
    metadata_title: string;
    others: boolean;
    prospect: string;
    pub_date: string | null;
    report_back: boolean;
    snippet: string;
    summary: string;
    timestamp: string;
    title: string | null;
    updatedAt: string;
    createdAt: string;
    uuid: string;
    role: string;
    isLive: boolean | null;
    reviewedByCM: boolean | false;
    findings?: {
        city_idm_value?:number;
        prov_idm_value: number;
        country_idm_value: number;
        industry_idm: number;           
        company_idm_value: number;
    };
    subtopics: string[];
    topic: string;
}
export interface individualArticles {
    accused: number;
    role: string;
    category: string;
    credible_link: boolean;
    sourceCategory?: string | "";
    trashCategory?: string | "";
    reviewedByCM: boolean |  false;
    detailed_prospect: string;
    findings: {
        city_idm_value: number;
        prov_idm_value: number;
        country_idm_value: number;
        company_idm_value: number;
        name_idm_value: number;
        relatives_names_idm_value: number;
        job_titles_idm_value: number;
        age_idm_value: number;
    };
    idm: string;
    idm_percent: string;
    isPublished: boolean;
    isTrash: boolean;
    language: string;
    link: string;
    metadata_description: string;
    metadata_image_url: string;
    metadata_site_name: string;
    metadata_title: string;
    prospect: string;
    pub_date: string;
    report_back: boolean;
    snippet: string;
    summary: string;
    timestamp: string;
    title: string;
    updatedAt: string;
    createdAt: string;
    uuid: string;
    isLive: boolean | null;
    subtopics: string[];
}

interface Individual {
    uuid: string;
    firstName: string;
    lastName: string;
    alternativeName: string;
    individualLocations: {
        uuid: string;
        city: string;
        country: string;
        countryLong: string;
        province: string;
    }[];
    organizationAndRoles: {
        uuid: string;
        role: string;
        organization: string;
    }[];
    yearOfBirth: string | null;
}

interface LEGAL_ENTITY {
    uuid: string;
    name: string;
    acronym: string;
    otherName: string;
    levLocations: {
        uuid: string;
        country: string;
        countryLong: string;
        province: string;
    }[];
    industries: {
        uuid: string;
        name_en: string;
        name_fr: string;
        isDefault: true,
    }[]
    hasPepSoe?: number;
}

export interface ValidationReport {
    uuid: string;
    individual: Individual | null;
    legalEntity: LEGAL_ENTITY;
    liveUpdate: boolean;
    lastUpdatedAt: string;
    privacy: string;
    status: string;
    throughBulk: boolean;
    type: 'LEGAL_ENTITY' | 'INDIVIDUAL';
    isPendingVerification: boolean;
    indicator: string;
    jobId: string;
    createdAt: any;
    updated_datetime:any;
    validationConsumptions: any;
    reviews:any;
    hasPepSoe: number | -1;
    individualReports: {
        articles: individualArticles[];
        totalScrapedCount: number;
        uuid: string;
    }[],
    report: {
        articles: individualArticles[] | levArticles[];
        totalScrapedCount: number;
        uuid: string;
        isPublished: boolean;
    }
}

export interface State {
    validations: Validation[];
    validation: ValidationReport | null;
    reportHistory: any;
    totalCount:number;
    loading: boolean;
    error: string | null;
    riskSummary?: { clear: number; investigate: number; high: number; loading: boolean };
}

const initialState: State = {
    validations: [],
    totalCount:0,
    validation: null,
    reportHistory:[],
    loading: false,
    error: null,
    riskSummary: { clear: 0, investigate: 0, high: 0, loading: false },
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action): State => {
    switch (action.type) {
        case GET_VALIDATIONS_REQUEST:
            return { ...state, loading: true, validation: null, validations: [], reportHistory:[], error: null };
        case GET_VALIDATIONS_SUCCESS:
            return {
                ...state,
                validations: action.payload.page === 0
                ? action.payload.validations // Replace data for first page
                : action.payload.validations, // Replace data for non-incremental pages
                totalCount: action.payload.totalCount,
                loading: false,
                error: null,
            };
        case GET_VALIDATIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_VALIDATION_REQUEST:
            return { ...state, loading: true, validation: null, validations: [], error: null };
        case GET_VALIDATION_SUCCESS:
            return { ...state, validation: action.payload, loading: false, error: null };
        case GET_VALIDATION_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_VALIDATION_HISTORY_REQUEST:
            return { ...state, reportHistory:[] };
        case GET_VALIDATION_HISTORY_SUCCESS:
            return { ...state, reportHistory: action.payload };
        case GET_VALIDATION_HISTORY_FAILURE:
            return { ...state, reportHistory: [] };
        case RESTART_VALIDATION_REQUEST:
            return { ...state, loading: true, validation: null, validations: [], error: null };
        case RESTART_VALIDATION_SUCCESS:
            return { ...state, validation: action.payload, loading: false, error: null };
        case RESTART_VALIDATION_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case BULK_RESTART_VALIDATIONS_REQUEST:
            return { ...state, loading: true, error: null };
        case BULK_RESTART_VALIDATIONS_SUCCESS:
            return { ...state, loading: false, error: null };
        case BULK_RESTART_VALIDATIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case RESET_VALIDATIONS_STATE:
            return { ...initialState }
        case GET_RISK_SUMMARY_REQUEST:
            return { ...state, riskSummary: { ...(state.riskSummary || { clear:0, investigate:0, high:0, loading:false }), loading: true } }
        case GET_RISK_SUMMARY_SUCCESS:
            return { ...state, riskSummary: { ...(state.riskSummary || { clear:0, investigate:0, high:0, loading:false }), ...action.payload, loading: false } }
        case GET_RISK_SUMMARY_FAILURE:
            return { ...state, riskSummary: { ...(state.riskSummary || { clear:0, investigate:0, high:0, loading:false }), loading: false } }
        default:
            return state;
    }
};

export default reducer;
